import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './WsrListItemSection.st.css';
import Divider from '../Divider';
import Text from '../Text';
import { WEIGHTS } from '../Text/constants';
import TextButton from '../TextButton';
import { dataHooks } from './constants';
import { isString } from '../utils/StringUtils';
import { WixStyleReactContext } from '../WixStyleReactProvider/context';
export const TYPES = {
    WHITESPACE: 'whitespace',
    DIVIDER: 'divider',
    TITLE: 'title',
    SUBHEADER: 'subheader',
};
/** ListItemSection description */
class ListItemSection extends React.PureComponent {
    constructor() {
        super(...arguments);
        this._renderDivisionElements = (children) => {
            const { dataHook, type } = this.props;
            return (React.createElement("div", { className: st(classes.root, { [type]: true }), "data-hook": dataHook, onClick: (e) => e.stopPropagation(), children: children }));
        };
        this._renderSuffix = () => {
            const { suffix, onClick, ellipsis } = this.props;
            return isString(suffix) ? (React.createElement("div", { className: classes.suffixWrapper },
                React.createElement(TextButton, { ellipsis: ellipsis, dataHook: dataHooks.SUFFIX, size: "tiny", onClick: onClick, className: classes.suffix }, suffix))) : (React.createElement("div", { "data-hook": dataHooks.SUFFIX, className: classes.suffixWrapper, onClick: onClick }, suffix));
        };
        this._renderTitle = () => {
            const { dataHook, className, type, title, suffix, ellipsis } = this.props;
            const isSubheader = type === TYPES.SUBHEADER;
            const getTextWeight = (newColorsBranding) => {
                if (!newColorsBranding) {
                    return WEIGHTS.thin;
                }
                return isSubheader ? WEIGHTS.normal : WEIGHTS.bold;
            };
            return (React.createElement(WixStyleReactContext.Consumer, null, ({ newColorsBranding }) => (React.createElement("div", { className: st(classes.root, {
                    subheader: isSubheader,
                    ellipsis,
                    suffix: !!suffix,
                    newColorsBranding,
                }, className), "data-hook": dataHook },
                React.createElement("div", { className: classes.titleWrapper },
                    React.createElement(Text, { dataHook: dataHooks.TITLE, tagName: "div", size: "small", className: classes.title, ellipsis: ellipsis, enterDelay: 300, weight: getTextWeight(newColorsBranding) }, title)),
                suffix && this._renderSuffix()))));
        };
    }
    render() {
        const { type } = this.props;
        if (type === TYPES.WHITESPACE) {
            return this._renderDivisionElements();
        }
        if (type === TYPES.DIVIDER) {
            return this._renderDivisionElements(React.createElement(Divider, null));
        }
        return this._renderTitle();
    }
}
ListItemSection.displayName = 'ListItemSection';
ListItemSection.propTypes = {
    dataHook: PropTypes.string,
    className: PropTypes.string,
    type: PropTypes.oneOf(Object.values(TYPES)),
    title: PropTypes.node,
    suffix: PropTypes.node,
    ellipsis: PropTypes.bool,
    onClick: PropTypes.func,
};
ListItemSection.defaultProps = {
    type: TYPES.TITLE,
    ellipsis: false,
};
export default ListItemSection;
export const listItemSectionBuilder = ({ id, className, dataHook, type, title, suffix, ellipsis, }) => ({
    id,
    overrideOptionStyle: true,
    disabled: true,
    value: (props) => (React.createElement(ListItemSection, { className: className, dataHook: dataHook, type: type, title: title, suffix: suffix, ellipsis: ellipsis, ...props })),
});
//# sourceMappingURL=ListItemSection.js.map